import { createLogger } from '@kurrent-ui/utils';

const logger = createLogger('@kurrent-ui/router', 'radial-gradient( circle farthest-corner at 10.2% 55.8%,  rgba(252,37,103,1) 0%, rgba(250,38,151,1) 46.2%, rgba(186,8,181,1) 90.1% )');

export { logger };
